<div class="container-fluid cw-background">
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-sm-9 col-sm-offset-1 col-md-9 col-md-offset-1 col-lg-10 col-lg-offset-1 mt-5 mb-5">
      <mat-card class="mat-elevation-z8" id="card">
        <div class="text-left go-back d-block">
          <button (click)="goBack()" disableRipple mat-button class="delete-user p-0">
            <mat-icon matPreffix>arrow_back_ios</mat-icon>
            Go Back
          </button>
          <h2 class="text-center card-title-page">Asset Bulk upload</h2>
        </div>

        <app-csv-download-button [downloadTemplateCallback]="downloadCSV"> </app-csv-download-button>

        <div class="my-4">
          <h6>Columns</h6>
          <code>
            <span [innerHtml]="getFileExampleColumns()"></span>
          </code>
        </div>

        <div class="my-4">
          <h6>Column Type</h6>
          <p>serialNumber: <code>required, unique</code></p>
          <p>name: <code>required</code></p>
          <p>description: <code>required</code></p>
          <p>
            category:
            <code>required</code><br />
            <small
              >values
              <code> subscription | workstations | server | storage | networking | other | unassigned</code>
            </small>
          </p>
          <p>modelNumber: <code>required</code></p>
          <p>companyIdentifier: <code>required</code></p>
          <p>type: <code>optional</code></p>
          <p>oem: <code>optional</code></p>
          <p>
            locationName: <code>optional</code><small><code> (the location should exist) </code></small>
          </p>
          <p *ngIf="currentUser.isGlobal()">
            {{ hasConfigurationNotesColumnName }}: <code>optional</code>
            <br />
            values
            <small>
              <code> yes/true, no/false</code>
            </small>
          </p>
          <p *ngIf="currentUser.isGlobal()">
            {{ fairMarketValueColumnName }}: <code>optional</code>
            <br />
            values
            <small>
              <code> [0.00 - 1000000.00] </code>
            </small>
          </p>
          <p *ngIf="currentUser.isGlobal()">
            {{ bookValueColumnName }}: <code>optional</code>
            <br />
            values
            <small>
              <code> [0.00 - 1000000.00] </code>
            </small>
          </p>

          <hr />
          Below are the terms to update a contract. Contract number is required for this action.
          <hr />
          <p>
            contractNumber: <code>optional - it must include the contract version. Ex: 12345-1</code
            ><small><code> (the contract should exist) </code></small>
          </p>
          <p>startDate: <code>optional</code></p>
          <p>endDate: <code>optional</code></p>
          <p>slaValue: <code>optional</code></p>
          <p>
            monitoring: <code>optional</code>
            <br />
            values
            <small>
              <code> yes/true, no/false </code>
            </small>
          </p>
          <p>
            DMR: <code>optional</code>
            <br />
            values
            <small>
              <code> yes/true, no/false</code>
            </small>
          </p>
          <p *ngIf="currentUser.isGlobal()">
            {{ internalProviderColumnName }}: <code>optional (existing internal provider name)</code>
          </p>
          <p *ngIf="currentUser.isGlobal()">
            {{ channelWorksCostColumnName }}: <code>optional</code>
            <small>
              <code> [0.00 - 100000.00] </code>
            </small>
          </p>
          <p *ngIf="currentUser.isGlobal()">
            partnerPrice: <code>optional</code>
            <small>
              <code>
                (In order for a partner price to be bulk uploaded, an asset has to be part of a CWM contract or part of
                a company with internal pricing = yes)</code
              >
              <br />
              values
              <code> [0.00 - 100000.00] </code>
            </small>
          </p>
          <p *ngIf="currentUser.isGlobal()">
            clientPrice: <code>optional</code>
            <small>
              <code>
                (In order for a client price to be bulk uploaded, an asset has to be part of a CWM contract or part of a
                company with internal pricing = yes)</code
              >
              <br />
              values
              <code> [0.00 - 100000.00] </code>
            </small>
          </p>
          <p *ngIf="currentUser.isPartner() || currentUser.isCompany()">
            clientPrice: <code>optional</code>
            <small>
              <code> (If you are experiencing any upload errors, please reach out to your CWM Sales Rep)</code>
              <br />
              values
              <code> [0.00 - 100000.00] </code>
            </small>
          </p>
          <p>
            decommissioned: <code>optional</code>
            <br />
            values
            <small>
              <code> yes/true, no/false </code>
            </small>
          </p>
        </div>

        <h6 class="my-4">No comma(,) allowed in data as is used as separator</h6>
        <div class="my-4">
          <h6>Example</h6>
          <div class="csv-code-example py-2 px-3">
            <code>
              <span [innerHtml]="getFileExampleColumns()"></span>
              <span [innerHtml]="getFileExampleBody()"></span>
            </code>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-12 col-sm-9 col-sm-offset-1 mt-4">
            <app-dynamic-form [questions]="questions" (formSubmit)="onSubmit($event)" [disabled]="loading">
            </app-dynamic-form>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
